<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/program-type-mgt">Program Type Management </a>
            </li>
            <li class="breadcrumb-item">Edit</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">
            <form [formGroup]="addProgramForm">
                <div class="main-block-innner">
                    <div class="add-store-block input-style">

                        <!-- **********************Subadmin profile image ****************  -->

                        <div class="form-group row my-3 align-items-center">
                            <label class="col-md-5">
                                <h6> Program Type :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" placeholder="Program Type"
                                    formControlName="title" maxlength="256"
                                    (keypress)="service.passwordKeyPress($event)" minlength="2">
                                @if(addProgramForm.get('title')?.hasError('required')&&
                                addProgramForm.get('title')?.dirty){
                                <span>
                                    <small class="text-danger">*Program type is required.</small>
                                </span>
                                }
                            </div>
                        </div>



                        <div class="text-center mb-3">
                            <button class="btn btn-theme" [disabled]="addProgramForm.invalid"
                                (click)="editProgram()">Update</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/program-type-mgt">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>